
import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import { bulidUid } from '@/libs/util.js'
import { Getter, Mutation } from 'vuex-class'
@Component
export default class HbslTable extends Vue {
    //红包扫雷
    redBol = true
    table = {
        data: [],
        column: <any>[]
    }
    //红包扫雷
    optTabledataHb = [
        {
            title: '发包玩家ID',
            align: 'center',
            render: (h, params) => {
                let bol = Array.isArray(JSON.parse(this.listdata[0].opt_detail))
                if (bol) {
                    return h('span', JSON.parse(params.row.opt_detail)[0].uid)
                } else {
                    return h('span', JSON.parse(params.row.opt_detail).uid)
                }
            }
        },
        {
            title: '发包数量',
            align: 'center',
            render: (h, params) => {
                let bol = Array.isArray(JSON.parse(this.listdata[0].opt_detail))
                if (bol) {
                    return h('span', JSON.parse(params.row.opt_detail)[0].packet.length)
                } else {
                    return h('span', JSON.parse(params.row.opt_detail).packet.length)
                }
            }
        },
        {
            title: '剩余没抢包数量',
            align: 'center',
            render: (h, params) => {
                let bol = Array.isArray(JSON.parse(this.listdata[0].opt_detail))
                if (bol) {
                    return h('span', JSON.parse(params.row.opt_detail)[0].l_n)
                } else {
                    return h('span', JSON.parse(params.row.opt_detail).l_n)
                }
            }
        },
        {
            title: '单个发包金额',
            align: 'center',
            render: (h, params) => {
                let bol = Array.isArray(JSON.parse(this.listdata[0].opt_detail))
                if (bol) {
                    return h('span', (this as any).getMoney(JSON.parse(params.row.opt_detail)[0].amount))
                } else {
                    return h('span', (this as any).getMoney(JSON.parse(params.row.opt_detail).amount))
                }
            }
        },
        {
            title: '雷号',
            align: 'center',
            render: (h, params) => {
                let bol = Array.isArray(JSON.parse(this.listdata[0].opt_detail))
                if (bol) {
                    return h('span', JSON.parse(params.row.opt_detail)[0].t)
                } else {
                    return h('span', JSON.parse(params.row.opt_detail).t)
                }
            }
        },
        {
            title: '发包次数',
            align: 'center',
            render: (h, params) => {
                let bol = Array.isArray(JSON.parse(this.listdata[0].opt_detail))
                if (bol) {
                    return h('span', JSON.parse(params.row.opt_detail).length)
                } else {
                    return h('span', '/')
                }
            }
        },
        {
            title: '发包总金额',
            align: 'center',
            render: (h, params) => {
                let bol = Array.isArray(JSON.parse(this.listdata[0].opt_detail))
                if (bol) {
                    return h('span', (this as any).getMoney(JSON.parse(params.row.opt_detail)[0].amount) * JSON.parse(params.row.opt_detail).length)
                } else {
                    return h('span', (this as any).getMoney(JSON.parse(params.row.opt_detail).amount))
                }
            }
        }
    ]
    //红包扫雷2发红包
    optTableRed = [
        { title: '抢包玩家ID', align: 'center', key: 'uid' },
        {
            title: '抢包金额',
            align: 'center',
            key: 'amount',
            render: (h, params) => {
                return h('span', (this as any).getMoney(params.row.amount))
            }
        },
        {
            title: '是否中雷',
            align: 'center',
            key: 'it',
            render: (h, params) => {
                return h('span', params.row.it ? '是' : '否')
            }
        },
        {
            title: '中雷金额',
            align: 'center',
            key: 'ta',
            render: (h, params) => {
                return h('span', (this as any).getMoney(params.row.ta))
            }
        }
    ]
    //红包扫雷2抢红包
    optTableQRed = [
        {
            title: '抢包玩家ID',
            align: 'center',
            key: 'uid',
            render: (h, params) => {
                return h('span', JSON.parse(params.row.opt_detail).uid)
            }
        },
        {
            title: '抢包金额',
            align: 'center',
            key: 'amount',
            render: (h, params) => {
                return h('span', (this as any).getMoney(JSON.parse(params.row.opt_detail).amount))
            }
        },
        {
            title: '雷号',
            align: 'center',
            key: 'thunder',
            render: (h, params) => {
                return h('span', JSON.parse(params.row.opt_detail).thunder ? JSON.parse(params.row.opt_detail).thunder : 0)
            }
        },
        {
            title: '是否中雷',
            align: 'center',
            key: 'IsThunder',
            render: (h, params) => {
                return h('span', JSON.parse(params.row.opt_detail).isThunder ? '是' : '否')
            }
        },
        {
            title: '中雷金额',
            align: 'center',
            key: 'thunderAmount',
            render: (h, params) => {
                return h('span', JSON.parse(params.row.opt_detail).isThunder ? (this as any).getMoney(JSON.parse(params.row.opt_detail).thunderAmount) : 0)
            }
        },
        {
            title: '红包倍数',
            align: 'center',
            key: 'Rate',
            render: (h, params) => {
                return h('span', JSON.parse(params.row.opt_detail).Rate)
            }
        },
        {
            title: '红包总个数',
            align: 'center',
            key: 'Num',
            render: (h, params) => {
                return h('span', JSON.parse(params.row.opt_detail).Num)
            }
        },
        {
            title: '剩余没抢红包个数',
            align: 'center',
            key: 'LastNum',
            render: (h, params) => {
                return h('span', JSON.parse(params.row.opt_detail).LastNum)
            }
        }
    ]
    getColumn() {
        let bol = Array.isArray(JSON.parse(this.listdata[0].opt_detail))
        if (bol) {
            this.table.column = this.optTabledataHb
            this.redBol = false
        } else {
            if (JSON.parse(this.listdata[0].opt_detail).packet) {
                this.table.column = this.optTabledataHb
                this.redBol = true
            } else {
                this.table.column = this.optTableQRed
                this.redBol = false
            }
        }
        return this.table.column
    }

    @Prop()
    listdata
}
